import React from 'react';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import { Box, Text } from '@adsk/alloy-react-box';
import { StampIcon } from '@adsk/alloy-react-icon';

import EntityMenuItem from '../../../EntityMenuItem';
import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import { SubmittalsItem } from '../types';
import { generateSubmittalItemLink } from '../utils/navigator';

const SubmittalsEntityMenuItem: Exclude<
  ReferencePickerPlugin<SubmittalsItem>['EntityMenuItem'],
  undefined
> = ({ entity, ...rest }) => {
  const projectId = useCurrentProjectId() as string;

  const { title, spec, identifier } = entity;

  const label = (
    <Box width="100%" typography="ellipsis" display="inline-flex">
      <Text marginRight="4px">
        #{identifier}-{spec.identifier}
      </Text>
      <Text typography="ellipsis">{title}</Text>
    </Box>
  );

  return (
    <EntityMenuItem
      key={entity.id}
      label={label}
      renderIcon={StampIcon.renderIcon}
      link={generateSubmittalItemLink(projectId, entity.id)}
      {...rest}
    />
  );
};

SubmittalsEntityMenuItem.displayName = 'SubmittalsEntityMenuItem';

export default SubmittalsEntityMenuItem;
